import { Component } from "@angular/core";
import { environment } from "environments/environment";

@Component({
    selector: "code-online",
    templateUrl: "./code-online.component.html",
    styleUrls: ["./code-online.component.scss"]
})
export class CodeOnlineCard {
    URL_CodeOnline = `${environment.URL_CODE_ONLINE}`;

}